module.exports = __webpack_public_path__ + "static/media/ccp-hero.843037c0.webp";